// extracted by mini-css-extract-plugin
module.exports = {"doc-page-wrapper":"D_cz container-lg d-flex p-3","doc-page":"D_cB","doc-page__title--enterprise":"D_cC","doc-page--with-side-menu":"D_cD","doc-page__title":"D_cF"};